import { FormattedMessage } from 'react-intl';

export const STRING_FIELD_TYPE = 'string';
export const CODE_FIELD_TYPE = 'code';
export const NUMBER_FIELD_TYPE = 'number';
export const PHONE_NUMBER_FIELD_TYPE = 'phone';
export const ACCOUNT_NUMBER_FIELD_TYPE = 'account';
export const BOOLEAN_FIELD_TYPE = 'boolean';
export const DATE_FIELD_TYPE = 'date';
export const TIME_FIELD_TYPE = 'time';
export const DAY_FIELD_TYPE = 'day';
export const VAT_FIELD_TYPE = 'vat';
export const DICTIONARY_FIELD_TYPE = 'dictionary';
export const PRICE_UNIT_FIELD_TYPE = 'priceUnit';
export const SELECT_FIELD_TYPE = 'select';
export const MULTI_SELECT_FIELD_TYPE = 'multiSelect';
export const COLOR_FIELD_TYPE = 'color';
export const TIME_UNIT_FIELD_TYPE = 'timeUnit';
export const DATE_TIME_FIELD_TYPE = 'dateTime';

export const requiredText = <FormattedMessage id="form.required" defaultMessage="Required" />;
export const required = value => (value || value === 0) && (!Array.isArray(value) || value.length > 0) ? undefined : requiredText;

export const NUMBERS_ONLY_ERROR = <FormattedMessage id="form.numbers.only" defaultMessage="Numbers only" />;
export const validateNumbersOnly = value => (isNaN(Number(value)) ? NUMBERS_ONLY_ERROR : undefined);

export const FOUR_NUMBERS_ONLY = <FormattedMessage id="four.numbers.only" defaultMessage="Required 4 digits" />;
export const validate4NumberDigits = value => (isNaN(Number(value)) || value.length !== 4) ? FOUR_NUMBERS_ONLY : undefined;